import { render, staticRenderFns } from "./TwTradingDataMapItem.vue?vue&type=template&id=577c0452&scoped=true&"
import script from "./TwTradingDataMapItem.vue?vue&type=script&lang=js&"
export * from "./TwTradingDataMapItem.vue?vue&type=script&lang=js&"
import style0 from "./TwTradingDataMapItem.vue?vue&type=style&index=0&id=577c0452&lang=scss&scoped=true&"
import style1 from "./TwTradingDataMapItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577c0452",
  null
  
)

export default component.exports